export default {
  // biome-ignore lint/suspicious/noConsole: logger utility
  debug: process.env.NODE_ENV !== 'production' ? console.log : () => {},
};
